import { render, staticRenderFns } from "./WebPartFormLinkDesigner.vue?vue&type=template&id=70ac70a9&"
import script from "./WebPartFormLinkDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormLinkDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ac70a9')) {
      api.createRecord('70ac70a9', component.options)
    } else {
      api.reload('70ac70a9', component.options)
    }
    module.hot.accept("./WebPartFormLinkDesigner.vue?vue&type=template&id=70ac70a9&", function () {
      api.rerender('70ac70a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormLinkDesigner.vue"
export default component.exports